/* Client voices (sections/client-voices.liquid).
   One shared <audio> for the whole page, so starting a note stops the one
   before it. A note that ends hands over to the next, as WhatsApp does; the
   waveform seeks by click, drag, or arrow keys, in the reading direction. */
(function () {
  var root = document.querySelector('[data-voices]');
  if (!root) return;
  var audio = root.querySelector('[data-voices-audio]');
  var notes = Array.prototype.slice.call(root.querySelectorAll('[data-vn]'));
  var allBtn = root.querySelector('[data-voices-all]');
  var allLabel = root.querySelector('[data-voices-all-label]');
  var t = { play: 'Play: ', pause: 'Pause: ', all: 'Play them all', stop: 'Stop' };
  try { t = JSON.parse(root.querySelector('[data-voices-i18n]').textContent); } catch (e) {}
  var current = null;

  function fmt(s) {
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }
  function dur(n) {
    return (audio.duration && isFinite(audio.duration) && n === current) ? audio.duration : +n.getAttribute('data-dur');
  }
  function name(n) { return n.querySelector('.vn-name').textContent; }

  function paint(n, time) {
    var d = dur(n), p = d ? Math.min(1, time / d) : 0;
    var bars = n.querySelectorAll('.vn-wave i'), on = Math.round(p * bars.length);
    for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('on', i < on);
    var wave = n.querySelector('[data-vn-wave]');
    wave.setAttribute('aria-valuenow', Math.floor(time));
    wave.setAttribute('aria-valuetext', fmt(time) + ' / ' + fmt(d));
    n.querySelector('[data-vn-time]').textContent = n === current && time > 0 ? fmt(time) : fmt(d);
  }

  function setPlaying(n, playing) {
    n.classList.toggle('is-playing', playing);
    n.querySelector('[data-vn-play]').setAttribute('aria-label', (playing ? t.pause : t.play) + name(n));
  }

  function select(n) {
    if (current === n) return;
    if (current) {
      setPlaying(current, false);
      current.classList.remove('is-current');
      var old = current;
      current = n;
      paint(old, 0);
    }
    current = n;
    n.classList.add('is-current');
    audio.preload = 'auto';
    audio.src = n.getAttribute('data-src');
  }

  function play(n, at) {
    select(n);
    if (typeof at === 'number') seekTo(at);
    var p = audio.play();
    if (p && p.catch) p.catch(function () {});
  }

  function seekTo(time) {
    if (audio.readyState >= 1) { audio.currentTime = time; }
    else {
      audio.addEventListener('loadedmetadata', function once() {
        audio.removeEventListener('loadedmetadata', once);
        audio.currentTime = time;
      });
    }
    paint(current, time);
  }

  function fraction(wave, clientX) {
    var r = wave.getBoundingClientRect();
    var f = (clientX - r.left) / r.width;
    if (getComputedStyle(wave).direction === 'rtl') f = 1 - f;
    return Math.max(0, Math.min(1, f));
  }

  notes.forEach(function (n, i) {
    var btn = n.querySelector('[data-vn-play]');
    var wave = n.querySelector('[data-vn-wave]');

    btn.addEventListener('click', function () {
      if (current === n && !audio.paused) audio.pause();
      else play(n);
    });

    var dragging = false;
    function fromPointer(e) {
      var time = fraction(wave, e.clientX) * dur(n);
      if (current !== n) play(n, time);
      else seekTo(time);
    }
    /* Mouse: press and drag to seek, as before. Touch: nothing happens on the
       first contact, so a thumb scrolling past the waveforms just scrolls (the
       browser keeps vertical panning, touch-action:pan-y). A tap seeks there and
       plays; a sideways drag scrubs. */
    var sx = 0, sy = 0, touch = false;
    wave.addEventListener('pointerdown', function (e) {
      touch = e.pointerType !== 'mouse';
      sx = e.clientX; sy = e.clientY;
      if (touch) return;
      dragging = true;
      try { wave.setPointerCapture(e.pointerId); } catch (err) {}
      fromPointer(e);
      if (current === n && audio.paused) play(n);
    });
    wave.addEventListener('pointermove', function (e) {
      if (dragging) { fromPointer(e); return; }
      if (touch && e.buttons !== 0 && Math.abs(e.clientX - sx) > 12 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) {
        dragging = true;
        try { wave.setPointerCapture(e.pointerId); } catch (err) {}
        fromPointer(e);
      }
    });
    wave.addEventListener('pointerup', function (e) {
      if (touch && !dragging && Math.abs(e.clientX - sx) < 10 && Math.abs(e.clientY - sy) < 10) {
        fromPointer(e);
        if (current === n && audio.paused) play(n);
      }
      dragging = false;
    });
    wave.addEventListener('pointercancel', function () { dragging = false; });

    wave.addEventListener('keydown', function (e) {
      var rtl = getComputedStyle(wave).direction === 'rtl';
      var step = { ArrowRight: rtl ? -5 : 5, ArrowLeft: rtl ? 5 : -5, ArrowUp: 5, ArrowDown: -5 }[e.key];
      if (e.key === 'Home') step = -1e9;
      if (e.key === 'End') step = 1e9;
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); btn.click(); return; }
      if (step === undefined) return;
      e.preventDefault();
      var from = current === n ? audio.currentTime : 0;
      var time = Math.max(0, Math.min(dur(n) - 0.2, from + step));
      if (current !== n) { select(n); }
      seekTo(time);
    });
  });

  audio.addEventListener('timeupdate', function () { if (current) paint(current, audio.currentTime); });
  audio.addEventListener('play', function () { if (current) setPlaying(current, true); syncAll(); });
  audio.addEventListener('pause', function () { if (current) setPlaying(current, false); syncAll(); });
  audio.addEventListener('ended', function () {
    var i = notes.indexOf(current);
    var n = current;
    setPlaying(n, false);
    paint(n, 0);
    if (i > -1 && i < notes.length - 1) {
      play(notes[i + 1]);
      /* keep the note that is playing on screen, without a scroll animation */
      var r = notes[i + 1].getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) notes[i + 1].scrollIntoView({ block: 'nearest' });
    } else {
      current.classList.remove('is-current');
      current = null;
      syncAll();
    }
  });

  function syncAll() {
    var playing = current && !audio.paused;
    allLabel.textContent = playing ? t.stop : t.all;
    allBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }
  allBtn.addEventListener('click', function () {
    if (current && !audio.paused) { audio.pause(); return; }
    play(current || notes[0]);
  });
})();
